<div class="tauxDePrise-decoupage cursorHelp" *ngIf="display()" pTooltip="taux de prise total pour '{{cellule.libelleDecoupageRepas.toUpperCase()}}'" >
  <i class="fas fa-users fa-xs mg-r-5"></i>{{cellule.tauxDePriseTotal | number:'1.2-2'}} %
</div>

